export default __webpack_public_path__ + "static/media/icon_ayuda_verde_oscuro.4d3b41ed.svg";